angular.module('impactx.ruleset').controller('RuleRequestListCtrl', ['$routeParams', 'selectedListItems', '$mdDialog', '$redirect', 'ConfirmationService',
    'TranslationService', 'ToastService', 'dataGen', RuleRequestListCtrl]);

function RuleRequestListCtrl($routeParams, selectedListItems, $mdDialog, $redirect,  ConfirmationService, TranslationService, ToastService, dataGen) {
    var ctrl = this;
    this.getDetailLink = function() {
        if (selectedListItems.getFirstSelectedItem()){
            return selectedListItems.getFirstSelectedItem().destination + "/" + selectedListItems.getFirstSelectedId() + "/" + $routeParams.RULESETId + "/" +
                selectedListItems.getFirstSelectedItem().ruleType;
        }
        else
        {
            return "";
        }
    };

    this.getRuleUserLink = function () {
        if (selectedListItems.getFirstSelectedItem().attributes.isMinAmountRuleUser) {
            return "ruleuserlist/minamount/" + selectedListItems.getFirstSelectedId()
        }
        else if (selectedListItems.getFirstSelectedItem().attributes.isInvoiceRuleUser) {
            return "ruleuserlist/invoice/" + selectedListItems.getFirstSelectedId();
        }
        else {
            return "ruleuserlist/default/" + selectedListItems.getFirstSelectedId();
        }
    };

    this.getRuleUserGroupLink = function() {
        return "ruleusergroup/" + selectedListItems.getFirstSelectedId()
    };

    this.createRule = function(event, actionLabel, trns, additionalFields) {
        $mdDialog.show({
            controller: "RuleCreationDialogCtrl",
            controllerAs: "ruleCreationDialogCtrl",
            templateUrl: "modules/ruleset/templates/rulecreationdialog.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                abortLabel: trns.abort,
                forwardLabel: trns.forward,
                options: additionalFields.createOptions
            }
        })
            .then(function(answer)
            {
                $redirect.redirectTo(null, answer.destinationPage + "/0/" + $routeParams.RULESETId + "/" + 20)
            }, function() {
            });
    };

    this.canDelete = function() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canDelete.value;
    };

    this.deleteDialog = function (event) {
        ConfirmationService.showConfirmationDialog(ctrl.delete, event,
            TranslationService.get('confirmDelete'), TranslationService.get('delete'), TranslationService.get('abort'));
    };

    this.delete = function() {
        dataGen.postAsForm({}, {id: selectedListItems.getFirstSelectedId()}, "/ruleset/deleterule").then(function () {
            ctrl.meta.refreshListData({unselectRow: selectedListItems.getFirstSelectedItem()});
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
        })
    };

    var buttonDefinition = [
        {label: "details", linkFunction: ctrl.getDetailLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'EditRuleSet'},
        {label: "ruleuser", linkFunction: ctrl.getRuleUserLink, type:'link', condition:  selectedListItems.isSingleSelection, process: 'EditRuleSet'},
        {label: "ruleusergroup", linkFunction: ctrl.getRuleUserGroupLink, type: 'link', condition: selectedListItems.isSingleSelection, process: 'EditRuleSet'},
        {label: "delete", action: ctrl.deleteDialog, condition: ctrl.canDelete, process: 'EditRuleSet'}
    ];

    this.meta = {
        rowTemplate: 'modules/ruleset/templates/ruleslist.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/ruleset/listrulesrequest',
        ctrl: this,
        id: "rulerequestlist",
        valuesInteger: [{name:"RULESETId", value: $routeParams.RULESETId},
            {name:"RULETYPE", value: 20}],
        mainActionFunction : {id:"new", action: this.createRule, icon:"mdi-plus"},
        buttonDefinition: buttonDefinition
    };

    this.getMeta = function () {
        return this.meta;
    };
}